import { Page } from '@/pages/AdvancedEditor/AdvancedEditor';
import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { checkPolotnoType } from '@/pages/AdvancedEditor/utils';

export const parsePageBeforeSaving = (page: any) => {
    return {
        ...page,
        // @ts-ignore
        children: (page.children || []).map((child: any) => ({
            ...child,
            type: checkPolotnoType(child, polotnoTypes.Avatar) ? polotnoTypes.Avatar : child.type,
            children: child.children?.map((child: any) => ({
                ...child,
                type: checkPolotnoType(child, polotnoTypes.Avatar) ? polotnoTypes.Avatar : child.type,
            })),
        })),
    };
};

export const parseStoreBeforeSaving = (storeJSON: any = {}) => {
    return {
        ...storeJSON,
        pages: (storeJSON?.pages || []).map(parsePageBeforeSaving),
    };
};

export const parseRawStore = (storeJSON: any = {}) => {
    return {
        ...storeJSON,
        ...(storeJSON?.pages
            ? {
                  pages: storeJSON?.pages.map((page: any) => ({
                      ...page,
                      // @ts-ignore
                      children: (page.children || []).map((child: any) => ({
                          ...child,
                          type: checkPolotnoType(child, polotnoTypes.Avatar) ? polotnoTypes.Image : child.type,
                          children: child.children?.map((child: any) => ({
                              ...child,
                              type: checkPolotnoType(child, polotnoTypes.Avatar) ? polotnoTypes.Image : child.type,
                          })),
                          custom: {
                              ...(child.custom || {}),
                              ...(checkPolotnoType(child, polotnoTypes.Avatar) ? { didType: polotnoTypes.Avatar } : {}),
                          },
                      })),
                  })),
              }
            : {}),
    };
};

export const mapPageToLayer = (page: Page) => {
    // @ts-ignore
    const { custom, temporary, ...pageRest } = page || { custom: {}, temporary: {} };

    return parsePageBeforeSaving(pageRest);
};

export const mapStoreToLayers = (storeJSON: any) => {
    const { custom, temporary, pages, ...store } = storeJSON || { pages: [], custom: {}, temporary: {} };

    return { ...store };
};

export const prepareLayerData = (mappedStore: any, mappedPages: any[]) => {
    return {
        ...mappedStore,
        pages: mappedPages,
    };
};
